import { type ValueOf } from './ValueOf';

export type PaymentsButtonPlace = 'onTopLevel' | 'insideShowMore';

export const PayPalFundingSources = {
  PayPal: 'paypal',
  PayPalCredit: 'credit',
  PayPalPayLater: 'paylater',
  PayPalVenmo: 'venmo',
} as const;

export type PayPalFundingSource = ValueOf<typeof PayPalFundingSources>;

/**
 * @summary Funding source names of payment methods - include fundingSources from Paypal PM, ApplePay && GooglePay PM's
 */

export const PaymentMethodFundingSources = {
  ...PayPalFundingSources,
  ApplePay: 'applePay',
  GooglePay: 'googlePay',
} as const;

export type PaymentMethodFundingSource = ValueOf<typeof PaymentMethodFundingSources>;
